import CityPageTemplate from "../city-template/CityPageTemplate";
import { dalyCityConfig } from "./data";

export default function DalyCityPage() {
  return <CityPageTemplate config={dalyCityConfig} />;
}